<form autocomplete="off" class="p-0" novalidate [formGroup]="CourseAtdThreshold">
  <div class="main-content side-content pt-0 ml-0">
    <div class="main-container container-fluid">
      <div class="inner-body">
        <div class="row row-sm add-form">
          <div class="col-lg-12 col-md-12">
            <div class="card custom-card">
              <div class="card-body pb-0">
                <div class="col-md-12 prpl">
                  <div class="d-flex align-items-center">
                    <img alt="Logo" src="../../assets/img/attendance.png" class="mh-45px pb-2">
                    <p class="mb-1">
                      <span class="main-content-label"><b>Course Wise Attendance Threshold Master</b></span><br>
                      <span class="text-muted card-sub-title mb-0">List Of Course Attendance Threshold</span>
                    </p>
                  </div>
                </div>
                <hr class="mt-2">

                <div class="row clearfix mt-2">

                  <!-- Faculty -->
                  <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="example-full-width">
                      <mat-label>{{ 'header.faculty-data.titleList.Faculty' | translate }}</mat-label>
                      <mat-select required #select33
                                  placeholder="Faculty"
                                  class="colorblack"
                                  formControlName="CoFcCode"
                                  (selectionChange)="onFacultyChange($event.value)">
                        <mat-select-filter *ngIf="select33.focused"
                                           [placeholder]="'Filter'"
                                           [displayMember]="'FcDesc'"
                                           [array]="fcCodeList"
                                           (filteredReturn)="filteredListFcCode = $event">
                        </mat-select-filter>
                        <mat-option *ngFor="let item of filteredListFcCode" [value]="item.FcCode">
                          {{ item.FcCode }} - {{ item.FcDesc }}
                        </mat-option>
                      </mat-select>
                      <mat-error class="margin_tp"
                                 *ngIf="CourseAtdThreshold.controls['CoFcCode']?.touched && CourseAtdThreshold.controls['CoFcCode'].errors?.required">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- Course (multi-select + Select All) -->
                  <div class="col-sm-3">
                    <mat-form-field appearance="outline" class="example-full-width">
                      <mat-label>Course</mat-label>
                      <mat-select multiple required #select23
                                  placeholder="Course"
                                  class="colorblack"
                                  formControlName="CoCode"
                                  [disabled]="!CourseAtdThreshold.get('CoFcCode').value"
                                  (selectionChange)="onCourseSelect($event)">
                        <mat-select-filter *ngIf="select23.focused"
                                           [placeholder]="'Filter'"
                                           [displayMember]="'CoName'"
                                           [array]="CourseList"
                                           (filteredReturn)="filteredListCourse = $event">
                        </mat-select-filter>

                        <!-- Select All -->
                        <mat-option
                            [value]="'selectAll'"
                            (click)="onSelectAllCourses()"
                            [selected]="isAllCoursesSelected()">
                          Select All
                        </mat-option>

                        <mat-option *ngFor="let item of filteredListCourse"
                                    [value]="item.CoCode"
                                    [selected]="selectedCourses.includes(item.CoCode)">
                          {{ item.CoCode }} - {{ item.CoName }}
                        </mat-option>
                      </mat-select>
                      <mat-error class="margin_tp"
                                 *ngIf="CourseAtdThreshold.controls['CoCode']?.touched && CourseAtdThreshold.controls['CoCode'].errors?.required">
                        Mandatory
                      </mat-error>
                    </mat-form-field>
                  </div>

                </div>

                <!-- Table -->
                <div *ngIf="Table" class="table-responsive sccc mt-4">
                  <div class="container">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th class="f600" width="8%">Sr.No</th>
                          <th class="f600" width="22%">Course Code</th>
                          <th class="f600" width="25%">Course Name</th>
                          <th class="f600">Theory</th>
                          <th class="f600">Practical</th>
                        </tr>
                      </thead>
                      <tbody id="table_data" formArrayName="AtArray">
                        <tr *ngFor="let row of getAtArrayControls(); let i = index" [formGroupName]="i">
                          <td>
                            <input readonly class="tab2 form-control input-sm" formControlName="SrNo">
                          </td>
                          <td>
                            <input readonly class="tab2 form-control input-sm" formControlName="CoCode"
                                   [title]="row.value.CoCode">
                          </td>
                          <td>
                            <input readonly class="tab2 form-control input-sm" formControlName="CoName">
                          </td>
                          <td>
                            <input class="tab3 form-control text-center"
                                   formControlName="TheoryPct"
                                   maxlength="3"
                                   (change)="onThresholdChange(i)"
                                   (keyup)="onInputChange($event, i, 'TheoryPct')">
                            <mat-error class="margin_tp mrgtp"
                                       *ngIf="row.controls.TheoryPct.touched && row.controls.TheoryPct.errors?.NonNumericError">
                              Invalid
                            </mat-error>
                            <mat-error class="margin_tp mrgtp"
                                       *ngIf="row.controls.TheoryPct.touched && row.controls.TheoryPct.errors?.PercentError">
                              Enter Less Than 100%
                            </mat-error>
                            <mat-error class="margin_tp mrgtp"
                                       *ngIf="row.controls.TheoryPct.touched && row.controls.TheoryPct.errors?.required">
                              Mandatory
                            </mat-error>
                          </td>
                          <td>
                            <input class="tab3 form-control text-center"
                                   formControlName="PracticalPct"
                                   maxlength="3"
                                   (change)="onThresholdChange(i)"
                                   (keyup)="onInputChange($event, i, 'PracticalPct')">
                            <mat-error class="margin_tp mrgtp"
                                       *ngIf="row.controls.PracticalPct.touched && row.controls.PracticalPct.errors?.NonNumericError">
                              Invalid
                            </mat-error>
                            <mat-error class="margin_tp mrgtp"
                                       *ngIf="row.controls.PracticalPct.touched && row.controls.PracticalPct.errors?.PercentError">
                              Enter Less Than 100%
                            </mat-error>
                            <mat-error class="margin_tp mrgtp"
                                       *ngIf="row.controls.PracticalPct.touched && row.controls.PracticalPct.errors?.required">
                              Mandatory
                            </mat-error>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-sm-12 mb-3">
                  <button type="button"
                          class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                          (click)="Save()"
                          *ngIf="SaveBtn && AtdSettingCreate"
                          [disabled]="saveDisable">
                    <span style="display: contents; align-items: center;">
                      <img width="15vh" src="../../assets/img/save.gif" style="margin-right: 7px;">
                      Save
                    </span>
                  </button>

                  <button type="button"
                          class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1"
                          (click)="update()"
                          *ngIf="UpdateBtn && AtdSettingUpdate"
                          [disabled]="updateDisable">
                    <span style="display: contents; align-items: center;">
                      <img width="15vh" src="../../assets/img/edit1.gif" style="margin-right: 7px;">
                      Update
                    </span>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>